<template>
  <div>

    <md-card>

      <md-card-content>

        <p>
          セット名（英語）、セット名（日本語）、作成者、フィガーを入力してください。「*(アスタリスク)」が付いている項目は必須項目です。
        </p>

        <!-- イベントの名称 -->
        <md-input-container
          md-clearable
          v-show="!setNameError">
          <label>セット名（英語）</label>
          <md-input
            required
            v-model="setName"></md-input>
        </md-input-container>
        <md-input-container
          md-clearable
          v-show="setNameError"
          class="md-input-invalid">
          <label>セット名（英語）</label>
          <md-input
            required
            v-model="setName"></md-input>
          <span
            class="md-error"
            v-model="setNameError">{{ setNameError }}</span>
        </md-input-container>

        <!-- イベントの名称 -->
        <md-input-container
          md-clearable
          v-show="!setNameJPError">
          <label>セット名（日本語）</label>
          <md-input
            required
            v-model="setNameJP"></md-input>
        </md-input-container>
        <md-input-container
          md-clearable
          v-show="setNameJPError"
          class="md-input-invalid">
          <label>セット名（日本語）</label>
          <md-input
            required
            v-model="setNameJP"></md-input>
          <span
            class="md-error"
            v-model="setNameJPError">{{ setNameJPError }}</span>
        </md-input-container>

        <!-- 開催者 -->
        <md-input-container
          md-clearable
          v-show="!editerNameError">
          <label>作成者</label>
          <md-input
            required
            v-model="editerName"></md-input>
        </md-input-container>
        <md-input-container
          md-clearable
          v-show="editerNameError"
          class="md-input-invalid">
          <label>作成者</label>
          <md-input
            required
            v-model="editerName"></md-input>
          <span
            class="md-error"
            v-model="editerNameError">{{ editerNameError }}</span>
        </md-input-container>

        <md-input-container>
          <label>セットの説明</label>
          <md-textarea v-model="notices"></md-textarea>
        </md-input-container>

        <!-- ムーブメント一覧 -->
        <md-card v-for="figure, figureIndex in figures" :key="figureIndex" class="figure">

          <md-card-header>
            <div class="md-title">Figure #{{ figure.order }}</div>
            <!-- <div class="md-subhead">
              <md-input
                required
                v-model="figureOverview"></md-input>
            </div> -->
            <md-select
              :placeholder="figure.rythmn"
              v-model="figure.rythmn">
              <md-option v-for="rythmn, rythmnIndex in ['Hornpipe', 'Jig', 'Polka', 'Quadrilles', 'Reel', 'Slide', 'Up Jig', 'Waltz']" value="rythmn" :key="rythmnIndex">{{ rythmn }}</md-option>
            </md-select>

            <md-input-container
              md-clearable
              v-show="!editerNameError">
              <label>フィガーの概要</label>
              <md-input
                required
                v-model="figure.description"></md-input>
            </md-input-container>
          </md-card-header>

          <md-card-content>

            <md-list class="figure-details">
              <md-list-item
                v-for="(movement, index) in figure.movements"
                v-if="movement.bar !== ''"
                :key="index"
                :class="movement.type"
                class="movement"
                @click="openMovementDialog('editMovementDialog', figureIndex, movementIndex, movement)">
                <span
                  v-if="movement.type === 'call-repeat'"
                  :class="movement.type"
                  class="bar"
                  key="callRepeatPart">
                  <md-chip class="md-primary">{{ movement.bar }}</md-chip>
                </span>
                <span
                  v-else-if="movement.type === 'repeat'"
                  :class="movement.type"
                  class="bar"
                  key="repeatPart">
                  <md-chip class="md-primary">{{ movement.bar }}</md-chip>
                </span>
                <span
                  v-else-if="movement.type === 'nested-repeat'"
                  :class="movement.type"
                  class="bar"
                  key="nestedRepeatPart">
                  <md-chip class="md-accent">{{ movement.bar }}</md-chip>
                </span>
                <span
                  v-else-if="movement.type === 'call-nested-repeat'"
                  :class="movement.type"
                  class="bar"
                  key="callNestedRepeatPart">
                  <md-chip class="md-accent">{{ movement.bar }}</md-chip>
                </span>
                <span v-else
                  :class="movement.type"
                  class="bar"
                  key="noramlPart">
                  <md-chip class="md-default">{{ movement.bar }}</md-chip>
                </span>
                <div class="md-list-text-container">
                  <span>
                    <!-- @click="openMovementCaption('captiondialog', figureIndex, movement.summary, movement.caption, movement.image)" -->
                    <md-button
                      @click="openMovementDialog('editMovementDialog', figureIndex, movementIndex, movement)"
                      class="summary">
                      {{ movement.summary }}<i class="material-icons">edit</i><div class="clear"></div>
                    </md-button>
                  </span>
                  <span
                    v-if="movement.subject"
                    key="movementWithSubject">
                    {{movement.subject}}
                  </span>
                </div>
                <md-divider v-if="index !== figure.movements.length - 1"></md-divider>
              </md-list-item>
            </md-list>

            <!-- <md-button
              class="md-raised"
              @click="">削除する</md-button> -->

            <md-button
              class="md-raised md-primary"
              @click="">動きを追加する</md-button>

          </md-card-content>

        </md-card>

        <md-button
          class="md-raised md-primary"
          @click="">フィガーを追加する</md-button>

      </md-card-content>

      <div class="controller">
        <!-- <md-button
          class="md-raised"
          @click="openDialog('deleteSetDialog')">削除する</md-button>
        <router-link
          tag="md-button"
          :to="{ name: 'Set', params: { setName: setName }}"
          class="md-raised">
          キャンセル
        </router-link> -->
        <md-button
          class="md-raised md-primary"
          @click="setEvent('dialog5')">更新する</md-button>
      </div>

    </md-card>

    <md-dialog
      md-open-from="#custom"
      md-close-to="#custom"
      ref="deleteSetDialog">
      <md-dialog-title>セットを削除します</md-dialog-title>

      <md-dialog-content>
        この操作は取り消せません。{{ setName }} Setを削除しますか？

      </md-dialog-content>

      <md-dialog-actions>
        <md-button
          class="md-primary"
          @click="cancelDialog('deleteSetDialog')">キャンセル</md-button>
        <md-button
          class="md-primary"
          @click="deleteSet('deleteSetDialog')">削除する</md-button>
      </md-dialog-actions>
    </md-dialog>

    <!-- 動きの追加 -->
    <md-dialog
      md-open-from="#custom"
      md-close-to="#custom"
      ref="editMovementDialog">
      <md-dialog-title>フィガーに動きを追加します</md-dialog-title>

      <md-dialog-content v-if="movement">

        <md-input-container>
          <label for="bar">小節数</label>
          <md-select
            :placeholder="String(movement.bar)"
            v-model="figures[figureIndex].movements[movementIndex].bar">
            <md-option v-for="bar, barIndex in [8, 16, 24, 32, 40, 48, 56, 64, 72, 80, 88, 96, 104, 112, 120, 128, 136, 144, 152, 160]" value="bar" :key="barIndex">{{ bar }}</md-option>
          </md-select>
        </md-input-container>

        <md-input-container
          v-show="!editerNameError">
          <label>要約（Lead Aroundなど）</label>
          <md-input
            required
            v-model="figures[figureIndex].movements[movementIndex].summary"></md-input>
        </md-input-container>

        <md-input-container>
          <label for="movie">動きをする人</label>
          <md-select
            :placeholder="movement.subject"
            :name="'subject' + movementIndex"
            :id="'subject' + movementIndex"
            v-model="figures[figureIndex].movements[movementIndex].subject">
            <md-option v-for="subject, subjectIndex in ['Everyone', 'Tops', 'Sides', '1st Top', '2nd Top', '1st Side', '2nd Side', '1st Gent & opposite Lady']" value="subject" :key="subjectIndex">{{ subject }}</md-option>
          </md-select>
        </md-input-container>

        <md-input-container>
          <label for="movie">繰り返し</label>
          <md-select
            :placeholder="しない"
            :name="'type' + movementIndex"
            :id="'type' + movementIndex"
            v-model="figures[figureIndex].movements[movementIndex].type">
            <md-option v-for="type, typeIndex in ['しない', 'Repeat']" value="type" :key="typeIndex">{{ type }}</md-option>
          </md-select>
        </md-input-container>

        <md-input-container
          v-show="!editerNameError">
          <label>動きの解説（オプション）</label>
          <md-input
            v-model="figures[figureIndex].movements[movementIndex].caption"></md-input>
        </md-input-container>

      </md-dialog-content>

      <md-dialog-actions>
        <md-button
          @click="cancelDialog('deleteSetDialog')">削除する</md-button>
        <md-button
          class="md-primary"
          @click="deleteSet('deleteSetDialog')">作成する</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog-confirm
      :md-title="confirm.title"
      :md-content-html="confirm.contentHtml"
      :md-ok-text="confirm.ok"
      :md-cancel-text="confirm.cancel"
      @open="onOpen"
      @close="onClose"
      ref="dialog5">
    </md-dialog-confirm>

    <form
      novalidate
      @submit.stop.prevent="openErrorConsole">
      <md-snackbar
        :md-position="'top center'"
        ref="snackbar"
        :md-duration="4000">
        <span>{{ errorMessage }}</span>
      </md-snackbar>
    </form>

  </div>
</template>

<script>
import db from '../db'

// db.ref('/events').once('value').then(function (events) {
//   console.log(events.val())
// })
// db.ref('/events/').remove()

export default {
  name: 'event',
  data () {
    return {
      setName: this.$route.params.setName,
      setNameJP: '',
      editerName: '',
      // url: '',
      notices: '',
      setNameError: '',
      setNameJPError: '',
      editerNameError: '',
      errorMessage: '',
      set: {},
      figures: [],
      movement: null,
      figureIndex: 0,
      movementIndex: 0,
      confirm: {
        title: '以下の内容でセットを更新します。よろしいですか？',
        contentHtml: 'content',
        ok: '更新する',
        cancel: 'キャンセル'
      }
    }
  },
  computed: {
    getCurrentYear () {
      return new Date().getFullYear()
    },
    getCurrentMonth () {
      return new Date().getMonth()
    },
    getCurrentDate () {
      return new Date().getDate()
    }
  },
  created () {
    let self = this
    db.ref('/originalSets/' + this.setName).once('value').then(function (set) {
      self.set = set.val()
      self.setSetData()
    })
  },
  watch: {
    '$route': 'refreashData'
  },
  methods: {
    refreashData () {
      let self = this
      db.ref('/originalSets/' + this.setName).once('value').then(function (set) {
        self.$set(self, 'set', set.val())
        self.setEventData()
      })
    },
    setSetData () {
      this.setName = this.set.name
      this.setNameJP = this.set.jpCaption
      this.editerName = this.set.editer
      this.notices = this.set.notices
      this.figures = this.set.figures

      if (!this.figures) {
        this.figures = [{
          order: 1,
          summary: 'Test',
          rythmn: 'Reel',
          description: 'test here',
          movements: [
            { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', description: 'すべてのカップルは cross hand で Lead Around する' },
            { bar: 8, subject: 'Everyone', summary: 'Swing', description: 'すべてのカップルは waltz hold で Swing する' },
            { bar: 8, subject: 'Everyone', summary: 'House inside', description: 'Leading Couple が House inside する', type: 'repeat' },
            { bar: 24, subject: '1st Side - 2nd Top - 2nd Side', summary: '<<Repeat ×3>>' },
            { bar: 8, subject: 'Everyone', summary: 'Swing' },
            { bar: 8, subject: 'Everyone', summary: 'House' }
          ]
        }]
      }
    },
    deleteSet (ref) {
      let self = this
      db.ref('/originalSets/' + this.setName).remove().then(function () {
        self.$router.push({ name: 'Home' })
      })
    },
    cancelDialog (ref) {
      this.$refs[ref].close()
    },
    setEvent (ref) {
      // <strong>anonymous</strong>
      let isError = false
      this.errorMessage = ''

      if (this.setName === '') {
        this.errorMessage += 'セット名（英語）を入力してください。'
        this.setNameError = 'セット名（英語）を入力してください。'
        isError = true
      } else {
        this.setNameError = ''
      }

      if (this.setNameJP === '') {
        this.errorMessage += 'セット名（日本語）を入力してください。'
        this.setNameJPError = 'セット名（日本語）を入力してください。'
        isError = true
      } else {
        this.setNameJPError = ''
      }

      if (this.editerName === '') {
        this.errorMessage += '作成者を入力してください。'
        this.editerNameError = '作成者を入力してください。'
        isError = true
      } else {
        this.editerNameError = ''
      }

      if (isError) {
        this.$refs.snackbar.open()
        return
      } else {
        this.errorMessage = ''
      }

      // let zeroFill = require('zero-fill')

      this.confirm.contentHtml = 'セット名：' + this.setName + '<br />作成者：' + this.editerName + '<br />セットの説明：' + this.notices.replace(/\n/g, '<br/>')
      this.$refs[ref].open()
    },
    setMovementIndex (figureIndex, movementIndex) {
      // this.movement = this.figures[figureIndex].movement[movementIndex]
    },
    openDialog (ref) {
      this.$refs[ref].open()
    },
    openMovementDialog (ref, figureIndex, movementIndex, movement) {
      this.figureIndex = figureIndex
      this.movementIndex = movementIndex
      this.movement = movement
      this.$refs[ref].open()
    },
    closeDialog (ref) {
      this.$refs[ref].close()
    },
    onOpen () {
    },
    onClose (type) {
      if (type !== 'ok') { return }
      let self = this
      // let originalSetsRef = db.ref('/originalSets').push()
      let originalSetsRef = db.ref('/originalSets')

      originalSetsRef.child(this.setName).set({
        name: this.setName,
        jpCaption: this.setNameJP,
        county: [this.setName],
        notices: this.notices,
        editer: this.editerName,
        referenceSite: null,
        lastModifiedTime: Date.parse(new Date()) * -1,
        figures: this.figures
      }).then(function () {
        self.$router.push({ name: 'Set', params: { setName: self.setName } })
      })
      // .catch(function (error) {})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.field-group {
  display: -webkit-flex; /* Safari */
  display: flex;
}
.md-input-container {
  /*display: flex;*/
}

h1, h2 {
  font-weight: normal;
}

.md-avatar.md-large {
  width: 113px;
  max-width: 113px;
  min-width: 113px;
}

.md-avatar {
  overflow: inherit;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  /*display: inline-block;*/
  margin: 0 10px;
}

a {
  color: #42b983;
}

#addEvent {
  margin: 24px 16px;
}


.figure.md-card .md-card-content {
  padding: 4px;
}

/* フィガーのスタイル指定 */
.figure-details .md-list-text-container .md-button {
  background-color: inherit;
  line-height: inherit;
  margin: 0;
  min-height: inherit;
  min-width: inherit;
  padding: 0;
  font-family: inherit;
  font-size: inherit;
  font-weight: bold;
  text-align: left;
  text-transform: none;
  width: 100%;
}

.figure-details .md-list-text-container .md-button i {
  position: absolute;
  right: 0;
  font-size: 20px;
  font-weight: normal;
  vertical-align: middle;
}

.figure-details .md-list-text-container > * {
  overflow: visible;
}

span.bar {
  width: 52px;
  margin-left: -16px;
  text-align: center;
}

span.bar.call-nested-repeat .md-theme-default.md-chip.md-accent {
  font-weight: bold;
}

span.bar.call-nested-repeat-connemara .md-theme-default.md-chip.md-accent {
  font-weight: bold;
}

span.type.common,
span.type.repeat,
span.type.call-repeat,
span.type.nested-repeat,
span.type.call-nested-repeat  {
  margin-right: -4px;
}

span.type.nested-repeat {
  font-weight: bold;
}

span.type.nested-repeat .md-theme-default.md-chip.md-primary {
  color: #f44336;
}

.movement.common {
  background-color: #efefef;
}

.movement.repeat,
.movement.nested-repeat,
.movement.call-nested-repeat {
  background-color: #ffcd87;
}

.movement.nested-repeat .summary,
.movement.nested-repeat .md-button.summary {
  color: #f44336;
}
/* 上記まで、フィガーのスタイル指定 */
</style>



// WEBPACK FOOTER //
// EditSet.vue?75f97a22